import { useState } from "react";

const Contact = () => {
  return(
    <div className="container">
      <h1>Contact</h1>
    </div>
  )
}

export default Contact;